import type { Market } from '../../types/entities/market';

/**
 * Строит map имен исходов по ctid
 */
export function buildOutcomesNamesByCtid(markets: Market[]): Map<number, string> {
    const names = new Map<number, string>();
    
    for (const market of markets) {
      for (const p of market.params) {
        names.set(p.ctid, p.name);
      }
    }
    
    return names;
}
